import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './ServicesSection.css';

function ServicesSection() {
  const [ref1, inView1] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const [ref2, inView2] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const [ref3, inView3] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <section id="services" className="services-section" style={{ overflowX: 'hidden' }}>
      <Container>
        <h2 className="services-title text-center">Servicios</h2>
        <Row className="mb-4" ref={ref1}>
          <Col md={6}>
            <motion.div initial={{ x: -1000 }} animate={{ x: inView1 ? 0 : -1000 }} transition={{ duration: 1, ease: "easeInOut" }}>
              <Card className="services-card">
                <Card.Img variant="top" src="/images/services1.png" />
              </Card>
            </motion.div>
          </Col>
          <Col md={6} className="my-auto text-center">
            <motion.div initial={{ x: 1000 }} animate={{ x: inView1 ? 0 : 1000 }} transition={{ duration: 1, ease: "easeInOut" }}>
              <h3>Desarrollo Web Completo</h3>
              <p>Creación, mantenimiento y optimización de:</p>
              <ul>
                <li>Landing Pages Atractivas</li>
                <li>Sitios Web dinámicos</li>
                <li>E-Commerces funcionales</li>
                <li>Aplicaciones Web a medida</li>
              </ul>
            </motion.div>
          </Col>
        </Row>

        <Row className="mb-4" ref={ref2}>
          <Col md={{ span: 6, order: 2 }}>
            <motion.div initial={{ x: 1000 }} animate={{ x: inView2 ? 0 : 1000 }} transition={{ duration: 1, ease: "easeInOut" }}>
              <Card className="services-card">
                <Card.Img variant="top" src="/images/services2.png" />
              </Card>
            </motion.div>
          </Col>
          <Col md={6} className="my-auto text-center">
            <motion.div initial={{ x: -1000 }} animate={{ x: inView2 ? 0 : -1000 }} transition={{ duration: 1, ease: "easeInOut" }}>
              <h3>Social Media Strategies</h3>
              <p>Impulsa tu presencia en línea mediante:</p>
              <ul>
                <li>Desarrollo de estrategias según tus objetivos</li>
                <li>Gestión integral de campañas publicitarias</li>
                <li>Creación de contenido de alto impacto</li>
                <li>Análisis exhaustivo de resultados</li>
              </ul>
            </motion.div>
          </Col>
        </Row>

        <Row className="mb-4" ref={ref3}>
          <Col md={6}>
            <motion.div initial={{ x: -1000 }} animate={{ x: inView3 ? 0 : -1000 }} transition={{ duration: 1, ease: "easeInOut" }}>
              <Card className="services-card">
                <Card.Img variant="top" src="/images/services3.png" />
              </Card>
            </motion.div>
          </Col>
          <Col md={6} className="my-auto text-center">
            <motion.div initial={{ x: 1000 }} animate={{ x: inView3 ? 0 : 1000 }} transition={{ duration: 1, ease: "easeInOut" }}>
              <h3>Tutorías Personalizadas</h3>
              <p>¡No te quedés con ninguna duda! Clases online:</p>
              <ul>
                <li>Matemática</li>
                <li>Informática</li>
                <li>Desarrollo Web</li>
                <li>Git Hub</li>
              </ul>
            </motion.div>
          </Col>
        </Row>

      </Container>
    </section>
  );
}

export default ServicesSection;
